const metrics = [
  {
    value: '$2.4M',
    label: 'Annual Security Savings',
    sublabel: 'vs. password resets & breaches',
  },
  {
    value: '15 hrs',
    label: 'Saved Per Employee/Year',
    sublabel: 'Password management time',
  },
  {
    value: '3 days',
    label: 'Faster Onboarding',
    sublabel: 'New hire time-to-productivity',
  },
  {
    value: '99.9%',
    label: 'Login Success Rate',
    sublabel: 'First-attempt authentication',
  },
]

function ROIMetrics() {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
      <div className="bg-gray-900 px-8 py-4">
        <h3 className="text-2xl font-bold text-white mb-2">Enterprise ROI</h3>
        <p className="text-gray-400">Real impact from FIDO Pre-reg deployment</p>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {metrics.map((metric) => (
            <div key={metric.label} className="text-center">
              <div className="text-4xl font-black text-yubico-green-400 mb-2">
                {metric.value}
              </div>
              <p className="text-sm text-gray-600 font-medium">{metric.label}</p>
              <p className="text-xs text-gray-400 mt-1">{metric.sublabel}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ROIMetrics
